import styled from "styled-components";
import { AppTheme } from "../theme";

export const Title = styled.div<{ theme: AppTheme }>`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-weight: 500;
  color: ${({ theme }) => theme.textReverse};
  font-size: 14px;
  width: 220px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0.9;
  letter-spacing: 0.02em;
`;

export const Loader = styled.div<{ theme: AppTheme }>`
  text-align: center;
  width: 200px;
  height: 50px;
  background: ${({ theme }) => theme.backgroundGlass};
  backdrop-filter: blur(12px);
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  border: 1px solid ${({ theme }) => theme.border};
`;

export const BigDate = styled.div<{ theme: AppTheme }>`
  font-family: 'Outfit', sans-serif;
  font-size: 2.25rem;
  max-width: calc(100vw - 160px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
  color: ${({ theme }) => theme.textReverse};
  margin-top: -6px;
  letter-spacing: -0.02em;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.15);
`;

// Glass card effect
export const GlassCard = styled.div<{ theme: AppTheme }>`
  background: ${({ theme }) => theme.backgroundGlass};
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1px solid ${({ theme }) => theme.border};
  border-radius: 1rem;
  padding: 1.25rem;
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ theme }) => theme.shadowMd};
  }
`;

// Modern card with shadow
export const Card = styled.div<{ theme: AppTheme }>`
  background: ${({ theme }) => theme.backgroundCard};
  border: 1px solid ${({ theme }) => theme.borderCard};
  border-radius: 1rem;
  padding: 1.25rem;
  box-shadow: ${({ theme }) => theme.shadowSm};
  transition: all 250ms cubic-bezier(0.4, 0, 0.2, 1);
  
  &:hover {
    box-shadow: ${({ theme }) => theme.shadowMd};
    transform: translateY(-2px);
  }
`;

// Badge/Pill component
export const Pill = styled.span<{ $color?: string; theme: AppTheme }>`
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.85rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  font-weight: 600;
  background: ${({ $color }) => $color || '#10B981'};
  color: white;
  letter-spacing: 0.02em;
  box-shadow: 0 2px 8px ${({ $color }) => $color ? `${$color}40` : 'rgba(16, 185, 129, 0.25)'};
  transition: all 200ms ease;
  
  &:hover {
    transform: scale(1.05);
  }
`;

// Section heading
export const SectionHeading = styled.h2<{ theme: AppTheme }>`
  font-family: 'Outfit', sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  color: ${({ theme }) => theme.text};
  letter-spacing: -0.02em;
  margin-bottom: 1rem;
`;
